"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeVerificationMilestoneKey = exports.PriorLienReleaseDocumentsMilestoneKey = exports.TrustVerificationMilestoneKey = exports.PostNotarizationReviewMilestoneKey = exports.EmploymentVerificationMilestoneKey = exports.FloodInsuranceMilestoneKey = exports.HazardInsuranceMilestoneKey = exports.LienPositionReviewMilestoneKey = exports.TitleInsuranceMilestoneKey = void 0;
var TitleInsuranceMilestoneKey;
(function (TitleInsuranceMilestoneKey) {
    TitleInsuranceMilestoneKey["titleReport"] = "titleReport";
    TitleInsuranceMilestoneKey["additionalInformation"] = "additionalInformation";
    TitleInsuranceMilestoneKey["manualReview"] = "manualReview";
    TitleInsuranceMilestoneKey["conditionCleared"] = "conditionCleared";
    TitleInsuranceMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(TitleInsuranceMilestoneKey || (exports.TitleInsuranceMilestoneKey = TitleInsuranceMilestoneKey = {}));
/** Lien-position review runs title's timeline without the report step: we do the review ourselves. */
var LienPositionReviewMilestoneKey;
(function (LienPositionReviewMilestoneKey) {
    LienPositionReviewMilestoneKey["lienReview"] = "lienReview";
    LienPositionReviewMilestoneKey["additionalInformation"] = "additionalInformation";
    LienPositionReviewMilestoneKey["manualReview"] = "manualReview";
    LienPositionReviewMilestoneKey["conditionCleared"] = "conditionCleared";
    LienPositionReviewMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(LienPositionReviewMilestoneKey || (exports.LienPositionReviewMilestoneKey = LienPositionReviewMilestoneKey = {}));
var HazardInsuranceMilestoneKey;
(function (HazardInsuranceMilestoneKey) {
    HazardInsuranceMilestoneKey["policy"] = "policy";
    HazardInsuranceMilestoneKey["review"] = "review";
    HazardInsuranceMilestoneKey["conditionCleared"] = "conditionCleared";
    HazardInsuranceMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(HazardInsuranceMilestoneKey || (exports.HazardInsuranceMilestoneKey = HazardInsuranceMilestoneKey = {}));
var FloodInsuranceMilestoneKey;
(function (FloodInsuranceMilestoneKey) {
    FloodInsuranceMilestoneKey["policy"] = "policy";
    FloodInsuranceMilestoneKey["lifeOfLoanPolicy"] = "lifeOfLoanPolicy";
    FloodInsuranceMilestoneKey["review"] = "review";
    FloodInsuranceMilestoneKey["actionNeeded"] = "actionNeeded";
    FloodInsuranceMilestoneKey["conditionCleared"] = "conditionCleared";
})(FloodInsuranceMilestoneKey || (exports.FloodInsuranceMilestoneKey = FloodInsuranceMilestoneKey = {}));
var EmploymentVerificationMilestoneKey;
(function (EmploymentVerificationMilestoneKey) {
    EmploymentVerificationMilestoneKey["automaticReview"] = "automaticReview";
    EmploymentVerificationMilestoneKey["documentUpload"] = "documentUpload";
    EmploymentVerificationMilestoneKey["manualReview"] = "manualReview";
    EmploymentVerificationMilestoneKey["conditionCleared"] = "conditionCleared";
    EmploymentVerificationMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(EmploymentVerificationMilestoneKey || (exports.EmploymentVerificationMilestoneKey = EmploymentVerificationMilestoneKey = {}));
var PostNotarizationReviewMilestoneKey;
(function (PostNotarizationReviewMilestoneKey) {
    PostNotarizationReviewMilestoneKey["automaticReview"] = "automaticReview";
    PostNotarizationReviewMilestoneKey["documentUpload"] = "documentUpload";
    PostNotarizationReviewMilestoneKey["manualReview"] = "manualReview";
    PostNotarizationReviewMilestoneKey["conditionCleared"] = "conditionCleared";
    PostNotarizationReviewMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(PostNotarizationReviewMilestoneKey || (exports.PostNotarizationReviewMilestoneKey = PostNotarizationReviewMilestoneKey = {}));
var TrustVerificationMilestoneKey;
(function (TrustVerificationMilestoneKey) {
    TrustVerificationMilestoneKey["documentUpload"] = "documentUpload";
    TrustVerificationMilestoneKey["manualReview"] = "manualReview";
    TrustVerificationMilestoneKey["conditionCleared"] = "conditionCleared";
    TrustVerificationMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(TrustVerificationMilestoneKey || (exports.TrustVerificationMilestoneKey = TrustVerificationMilestoneKey = {}));
// An e-sign borrower authorization waiting on the borrower is its own key so it can say so while current. A wet-signed
// one is uploaded and then reviewed, so it gets a second manual review step.
var PriorLienReleaseDocumentsMilestoneKey;
(function (PriorLienReleaseDocumentsMilestoneKey) {
    PriorLienReleaseDocumentsMilestoneKey["payoffQuoteUpload"] = "payoffQuoteUpload";
    PriorLienReleaseDocumentsMilestoneKey["manualReview"] = "manualReview";
    PriorLienReleaseDocumentsMilestoneKey["borrowerAuthorization"] = "borrowerAuthorization";
    PriorLienReleaseDocumentsMilestoneKey["borrowerAuthorizationAwaitingESign"] = "borrowerAuthorizationAwaitingESign";
    PriorLienReleaseDocumentsMilestoneKey["borrowerAuthorizationManualReview"] = "borrowerAuthorizationManualReview";
    PriorLienReleaseDocumentsMilestoneKey["conditionCleared"] = "conditionCleared";
})(PriorLienReleaseDocumentsMilestoneKey || (exports.PriorLienReleaseDocumentsMilestoneKey = PriorLienReleaseDocumentsMilestoneKey = {}));
var IncomeVerificationMilestoneKey;
(function (IncomeVerificationMilestoneKey) {
    IncomeVerificationMilestoneKey["automaticReview"] = "automaticReview";
    IncomeVerificationMilestoneKey["manualReview"] = "manualReview";
    IncomeVerificationMilestoneKey["plaidConnection"] = "plaidConnection";
    IncomeVerificationMilestoneKey["conditionCleared"] = "conditionCleared";
    IncomeVerificationMilestoneKey["conditionNotMet"] = "conditionNotMet";
})(IncomeVerificationMilestoneKey || (exports.IncomeVerificationMilestoneKey = IncomeVerificationMilestoneKey = {}));
